import { useAutoAnimate } from "@formkit/auto-animate/react"
import { useContext, useState } from "react"
import { Context } from "../../store/store"
import Popup from "../elements/Popup"
import ReceiptUpload from "./ReceiptUpload"
import { getText } from "../strapi"

const Receipt = () => {
	const { globalState } = useContext(Context)
	const [showSample, setShowSample] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	return (
		<section className="js-mitmachen  relative pb-20 pt-12 md:pt-28 sm:px-4  ">
			<div className="container mx-auto text-center">
				<h2 className="mb-2 text-white">{getText(globalState.strapi.homepage.receiptHeadline, "receiptHeadline")}</h2>
				<p className="copy pb-8 text-white ">{getText(globalState.strapi.homepage.receiptCopy, "receiptCopy")}</p>
				<div className="p-1 sm:p-4">
					<div className="arrow-white mx-auto max-w-[464px] rounded-lg border-[2px] border-dashed border-white bg-[#66af85] px-4">
						<ReceiptUpload />
					</div>
				</div>
				<div>
					<p className="mx-auto mt-2 max-w-[600px] text-center text-white underline text-[14px]">
						<span className="cursor-pointer underline" onClick={() => setShowSample(true)}>
							{getText(globalState.strapi.homepage.receiptSample, "receiptSample")}
						</span>
					</p>
				</div>
			</div>
			<div ref={animationRef}>
				{showSample && (
					<Popup close={() => setShowSample(false)}>
						<img src={"/images/kassenbon-beispiel-mobile.jpg"} alt="" className="mx-auto block h-auto lg:hidden" />
						<img src={"/images/kassenbon-beispiel.jpg"} alt="" className="mx-auto hidden h-auto lg:block" />
					</Popup>
				)}
			</div>
		</section>
	)
}

export default Receipt
